'use strict';

module.exports = {
    // sections
    root: 'root',
    video: 'video',
    graphicResolution: 'graphicResolution',
    tvSystem: 'tvSystem'
};
